import { FC } from 'react';
import Heading from 'raydiant-elements/core/Heading';
import Column from 'raydiant-elements/layout/Column';
import ApplicationInputID from './ApplicationInputID';
import ApplicationInputOptions from './ApplicationInputOptions';
import ApplicationInputRequired from './ApplicationInputRequired';
import ApplicationInputHelperText from './ApplicationInputHelperText';
import ApplicationInputHelperLink from './ApplicationInputHelperLink';

interface ApplicationInputTypeButtonGroupProps {}

const ApplicationInputTypeButtonGroup: FC<ApplicationInputTypeButtonGroupProps> = () => {
  return (
    <Column doubleMargin>
      <Column>
        <Heading overline size={5}>
          Properties
        </Heading>
        <ApplicationInputID />
        <ApplicationInputOptions />
      </Column>

      <Column>
        <Heading overline size={5}>
          Validation
        </Heading>
        <ApplicationInputRequired />
      </Column>

      <Column>
        <Heading overline size={5}>
          Appearance
        </Heading>
        <ApplicationInputHelperText />
        <ApplicationInputHelperLink />
      </Column>
    </Column>
  );
};

export default ApplicationInputTypeButtonGroup;
